<template>
  <div class="s-price-container container s-dealmakers-container">
    <topNav></topNav>
    <div class="s-price-top">
      <div class="banner w1300 marginAuto"></div>
    </div>

    <div class="conditions w1300 marginAuto">
      <el-row class="conditions-row">
        <div class="conditions-row-1">
          <div class="conditions-colName">产品分类</div>
          <div class="conditions-colContent">
            <span v-for="(ite, inde) in categoryList" :key="inde" class="col-span"
              :class="inde == active3 ? 'active' : ''" @click="checkList(3, inde, ite.id, '产品分类')">{{ ite.name }}</span>
          </div>
        </div>
        <div class="conditions-row-1">
          <div class="conditions-colName">产品类型</div>
          <div class="conditions-colContent col_middle">
            <span v-for="(item, index) in classificationList" :key="index" class="col-span"
              :class="active1 == index ? 'active' : ''" @click="checkList(1, index, item.id, '产品类型')">{{ item.name
              }}</span>
          </div>
        </div>
        <div class="conditions-row-1">
          <div class="conditions-colName col_middle">产品名称</div>
          <div class="conditions-colContent">
            <span v-for="(itm, ind) in ProductCategoriesList" :key="ind" class="col-span"
              :class="ind == active2 ? 'active' : ''" @click="checkList(2, ind, itm.id, '产品名称')">{{ itm.name }}</span>
          </div>
        </div>
      </el-row>
    </div>
    <!-- <div class="section">
      <p class="title_chinese">价格行情</p>
      <hr class="title_hr" />
      <p class="title_english">MATCHMAKING TRADEOFF</p>
    </div>-->
    <div class="w1300 marginAuto queryDiv">
      <div class="query">
        <el-input v-model="queryKey" placeholder="请输入关键词搜索" class="search_input">
          <template v-slot:suffix>
            <i class="el-input__icon el-icon-search" @click="getListByPageInfo" @keyup.enter="getListByPageInfo"></i>
          </template>
        </el-input>
        <div class="issue" @click="getListByPageInfo">搜索</div>
      </div>
    </div>

    <div class="section-list w1300 marginAuto">
      <table align="center" cellspacing="0" cellpadding="0" class="table_title table_green_title">
        <thead>
          <tr>
            <th>序号</th>
            <th>数据时间</th>
            <th>产品分类</th>
            <th>产品类型</th>
            <th>产品名称</th>
            <th>价格</th>
            <th>涨跌幅</th>
            <th>走势图</th>
          </tr>
        </thead>
      </table>
      <table align="center" cellspacing="0" cellpadding="0" class="table_content table_green">
        <tbody>
          <tr v-for="(item, index) in marketPriceList" :key="item.id">
            <td>{{ (currentPage - 1) * 10 + (index + 1) }}</td>
            <td>{{ item.dataTime }}</td>
            <td>{{ item.classifyValue }}</td>
            <td>{{ item.typeValue }}</td>
            <td>{{ item.varietiesValue }}</td>
            <td>{{ item.price }}元</td>
            <td :class="item.percentage >= 0 ? 'color_change1' : 'color_change2'">
              <!-- {{ item.proportion >= 0 ? "↑" : "↓" }}{{ item.proportion.indexOf('-')>=0 ||item.proportion.indexOf('+')>=0? item.proportion.slice(1):item.proportion }}% -->
              {{
                item.percentage != null
                ? item.percentage >= 0
                  ? "↑"
                  : "↓"
                : ""
              }}{{
  item.percentage != null
  ? item.percentage.indexOf("-") >= 0
    ? item.percentage.slice(1)
    : item.percentage
  : ""
}}%
            </td>
            <td>
              <p style="cursor: pointer" @click="handleMovements(item.id)">走势行情</p>
            </td>
            <!-- <p @click="trendOpen(item)"  style="cursor: pointer">查看详情</p> -->
          </tr>
        </tbody>
      </table>
      <el-pagination class="tab_pagination" background :pageSize="pageSize" layout="prev, pager, next"
        @current-change="currentChange" :total="total"></el-pagination>
    </div>
    <!-- <div class="section">
      <p class="title_chinese">价格指数</p>
      <hr class="title_hr" />
      <p class="title_english">MATCHMAKING TRADEOFF</p>
    </div>-->
    <div class="sectionCharts w1300 marginAuto">
      <!-- <div class="query queryDiv">
        <el-select
          v-model="selectCharts"
          class="search_input"
          placeholder="请选择"
          @change="changeReports"
        >
          <el-option
            v-for="item in selectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>-->
      <div class="indexPart">
        <div class="item_indexBox" style="position: relative">
          <div class="titleBox">
            茶青价格预警
            <el-tooltip placement="bottom" effect="light" popper-class="tooltip_box">
              <div class="tooltip_content" slot="content">价格指数: 报告期与基期相比商品价格水平的变化趋势和变化程度的相对数</div>
              <img src="../assets/image/price/mark_c.png" alt srcset />
            </el-tooltip>
          </div>
          <div class="query queryDiv1">
            <el-select v-model="cqVarietiesValue" size="small" style="margin-left:10px" class="search_input1"
              placeholder="请选择" @change="changeCqVarieties">
              <el-option v-for="item in cqVarietiesOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>

            <el-select v-model="cqWarningTypeValue" size="small" style="margin-left:10px" class="search_input1"
              placeholder="请选择" @change="changeCqWarning">
              <el-option v-for="item in cqTypeOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="indexCharts" id="teaPriceWarningCharts" ref="teaPriceWarningCharts" style="height: 100%"></div>
        </div>
        <div class="item_indexBox">
          <div class="titleBox">
            茶青价格指数
            <el-tooltip placement="bottom" effect="light" popper-class="tooltip_box">
              <div class="tooltip_content" slot="content">价格指数: 报告期与基期相比商品价格水平的变化趋势和变化程度的相对数</div>
              <img src="../assets/image/price/mark_c.png" alt srcset />
            </el-tooltip>
          </div>
          <div class="tooltipBox">
            <div class="subTitle">今日指数</div>
            <div class="content">
              <el-row>
                <el-col :span="8" v-for="(item, index) in cqToolTipList" :key="index">
                  <div class="item_content_box">
                    <span class="l_name">{{ item.name }}</span>
                    <span class="r_btn_val" :style="{ background: item.color }">{{ item.index }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="query queryDiv1">
            <!-- <el-select v-model="cqSelectCharts" class="search_input1" placeholder="请选择">
              <el-option v-for="item in selectOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>-->
            <el-select v-model="cqIndexDateTypeValue" size="small" style="margin-left:10px" class="search_input1"
              placeholder="请选择" @change="changeCqIndexDate">
              <el-option v-for="item in cqDateOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <el-select v-model="cqIndexTypeValue" size="small" style="margin-left:10px" class="search_input1"
              placeholder="请选择" @change="changeCqIndex">
              <el-option v-for="item in cqTypeOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>

          </div>
          <div class="indexCharts" id="cqPriceIndexCharts" ref="cqPriceIndexCharts"></div>
        </div>
      </div>
    </div>
    <!-- 新增指数分析报告模块暂未对接230803 -->
    <div class="section-list w1300 marginAuto">
      <div class="index_title">
        指数分析报告
        <div class="repor_select">
          <el-select v-model="indexReportTypeValue" size="small" style="margin-left:10px"
            placeholder="请选择" @change="changeIndexReportDate">
            <el-option v-for="item in indexReporOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <table align="center" cellspacing="0" cellpadding="0" class="table_title table_green_title">
        <thead>
          <tr>
            <th>日期</th>
            <th>报告类型</th>
            <th>文章标题</th>
          </tr>
        </thead>
      </table>
      <table align="center" cellspacing="0" cellpadding="0" class="table_content table_green">
        <tbody v-if="indexReportList.length>0">
          <tr v-for="(item, index) in indexReportList" :key="item.id">
            <td>{{ item.dataTime }}</td>
            <td>{{ item.reportType==0?"日报":item.reportType==1?"周报":item.reportType==2?"月报":item.reportType==3?"季报":item.reportType==3?"年报":'--'}}</td>
            <td>
              <p style="cursor: pointer" @click="indexReportDetails(item)">{{ item.title }}</p>
            </td>
          </tr>
        </tbody>
        <div class="report_content" v-else>暂无数据</div>
      </table>
      <el-pagination class="tab_pagination" background :pageSize="pageSize" layout="prev, pager, next"
        @current-change="reportCurrentChange" :total="reporTotal"></el-pagination>
    </div>
    <footerNav></footerNav>
    <el-dialog title="走势图" :visible.sync="trendChartDialog" :before-close="trendChartDialogClose"
      class="trendChart-dialog">
      <div>
        <span>时间：</span>
        <el-select v-model="dialogSelectCharts" @change="changeTrendChart" style="width:150px" placeholder="请选择">
          <el-option v-for="item in timeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="charts" id="priceCharts" style="width: 100%;"></div>
    </el-dialog>
    <el-dialog :title="reporTitle" :visible.sync="indexReportDialog" :before-close="indexReportDialogClose"
      class="trendChart-dialog">
      <div class="processAnalysis_detail_dialog_top">
        <span class="date">
          发布时间：{{ indexReporItem.dataTime ? indexReporItem.dataTime : '--' }}
        </span>
        <span class="source">
          来源：{{ indexReporItem.source ? indexReporItem.source : '--' }}
        </span>
      </div>
      <div class="index_repor_content">
        <p v-html="indexReporItem.startMsg+indexReporItem.teaGreenConclusion"></p>
        <p v-html="indexReporItem.teaSortConclusion"></p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";

import commonEcharts from "../utils/js/commobEcharts";
import { BarLineCharts } from "../utils/js/commonEcharts2";
import {
  getTypeList,
  getPriceQuotationListPage,
  getMovementsDetails,
  getCqPriceWarningData,
  getCqPriceIndexData,
  indexReportSelectListByPage
} from "./../utils/api/priceQuotation";

export default {
  name: "priceQuotation",
  components: { topNav, footerNav },
  data() {
    return {
      trendChartDialog: false,
      indexReportDialog:false,
      dialogSelectCharts: "0",
      timeOptions: [
        {
          value: "0",
          label: "日度"
        },
        {
          value: "1",
          label: "季度"
        },
        {
          value: "2",
          label: "年度"
        }
      ],
      classificationList: [],
      categoryList: [],
      ProductCategoriesList: [],
      active1: 0,
      active2: 0,
      active3: 0,
      currentPage: 1, // 页码
      reportCurrentPage:1,
      pageSize: 10, // 每页显示数量
      total: 1, // 总数
      queryKey: "",
      typeId: 0,
      classifyId: 0,
      varietyId: 0,
      reporTotal:0,
      marketPriceList: [],
      reporTitle:'',
      indexReportTypeValue: "0", //茶青价格指数
      indexReportList: [],
      indexReporItem: {},
      indexReporOptions: [
        {
          value: "0",
          label: "日度"
        }, {
          value: "1",
          label: "周度"
        }, {
          value: "2",
          label: "月度"
        }, {
          value: "3",
          label: "季度"
        }, {
          value: "4",
          label: "年度"
        },
      ],
      selectCharts: "0",
      selectOptions: [
        {
          value: "0",
          label: "日度指数"
        },
        {
          value: "1",
          label: "季度指数"
        },
        {
          value: "2",
          label: "年度指数"
        }
      ],
      cqSelectCharts: "0",
      cqIndexTypeValue: "一芽多叶", //茶青价格指数
      cqIndexDateTypeValue: "日度", //茶青价格指数
      cqWarningTypeValue: "一芽多叶", //茶青价格预警
      cqVarietiesValue: "福云6号", //茶青价格预警 茶青品种
      cqVarietiesOptions: [
        //茶青价格预警 茶青品种
        {
          value: "福云6号",
          label: "福云6号"
        },
        {
          value: "福鼎大白",
          label: "福鼎大白"
        },
        {
          value: "金牡丹",
          label: "金牡丹"
        },
        {
          value: "福鼎大毫",
          label: "福鼎大毫"
        },
        {
          value: "福云7号",
          label: "福云7号"
        },
        {
          value: "金观音",
          label: "金观音"
        },
        {
          value: "福安大白",
          label: "福安大白"
        }
      ],
      cqTypeOptions: [
        {
          value: "单芽",
          label: "单芽"
        },
        {
          value: "一芽一叶",
          label: "一芽一叶"
        },
        {
          value: "一芽两叶",
          label: "一芽两叶"
        },
        {
          value: "一芽多叶",
          label: "一芽多叶"
        }
      ],
      cqDateOptions: [
        {
          value: "日度",
          label: "日度"
        }, {
          value: "周度",
          label: "周度"
        }, {
          value: "月度",
          label: "月度"
        }, {
          value: "季度",
          label: "季度"
        }, {
          value: "年度",
          label: "年度"
        },
      ],
      dayReports: {},
      quarterReports: {},
      yearReports: {},
      dataId: "",
      // teaToolTipList: [],
      cqToolTipList: []
    };
  },
  mounted() {
    this.getTypeList(0, 0); // 类型列表
    this.getPriceQuotationListPage();

    this.getCqPriceWarningData(); //茶青价格预警
    this.getCqPriceIndexData(); //茶青价格指数
    this.indexReportSelectListByPage()//茶青价格指数分析报告
  },
  methods: {
    // openDialog(){
    //   this.getMovementsDetails();
    // },
    //走势图弹窗
    trendChartDialogClose() {
      this.trendChartDialog = false;
      this.dialogSelectCharts = "0";
    },
    //走势图弹窗时间点击事件
    changeTrendChart(value) {
      this.changeReports(value);
    },

    // 获取类型列表
    async getTypeList(typeId, classId, type) {
      let res = await getTypeList({ classId, typeId });
      console.log(res.data.data, "res.data.data");
      if (res.data.code == 0) {
        if (type == "产品分类") {
          this.classificationList = res.data.data.typeList;
          this.ProductCategoriesList = res.data.data.varietiesList;
        } else if (type == "产品类型") {
          this.ProductCategoriesList = res.data.data.varietiesList;
        } else {
          this.categoryList = res.data.data.classifyList;
          this.classificationList = res.data.data.typeList;
          this.ProductCategoriesList = res.data.data.varietiesList;
        }
      }
    },
    // 价格行情列表
    async getPriceQuotationListPage() {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        queryKey: this.queryKey ? this.queryKey : undefined,
        typeId: this.typeId,
        classifyId: this.classifyId,
        varietyId: this.varietyId
      };
      let res = await getPriceQuotationListPage(params);
      if (res.data.code == 0) {
        this.marketPriceList = res.data.data.records;
        this.total = res.data.data.total;
        // // 初始化默认显示第一条数据的趋势图
        // if (this.marketPriceList.length > 0) {
        //   this.dataId = this.marketPriceList[0].id;
        //   this.getMovementsDetails();
        // }else{
        //   this.changeReports()
        // }
      }
    },
    // 茶青价格指数分析报告
    async indexReportSelectListByPage() {
      let data = {
        reportType: this.indexReportTypeValue,
        currentPage: this.reportCurrentPage,
        pageSize: this.pageSize,
      }
      let res = await indexReportSelectListByPage(data)
      if ([200,0].includes(res.data.code)) {
        console.log(res.data.data, '茶青价格指数分析报告');
        this.indexReportList = res.data.data.records;
        this.reporTotal = res.data.data.total;
      }
    },
    // 搜索
    getListByPageInfo() {
      this.currentPage = 1;
      this.getPriceQuotationListPage();
    },
    // 点击表格的走势图
    handleMovements(id) {
      this.dataId = id;
      this.trendChartDialog = true;
      this.getMovementsDetails();
    },
    // 指数分析报告详情
    indexReportDetails(item) {
      console.log(item);
      this.reporTitle = item.title
      this.indexReporItem = item;
      this.indexReportDialog = true;
    },
    //走势图弹窗
    indexReportDialogClose() {
      this.indexReportDialog = false;
    },
    // 价格行情走势图
    async getMovementsDetails() {
      let res = await getMovementsDetails({ id: this.dataId });
      if (res.data.code == 0) {
        this.dayReports = res.data.data.dayReports; // 日度数据
        this.quarterReports = res.data.data.quarterReports; // 季度数据
        this.yearReports = res.data.data.yearReports; // 年度数据
        this.changeReports(this.dialogSelectCharts);
      }
    },
    // 调整日度季度年度
    changeReports(value) {
      let xAxisData = [];
      let legendData = ["日度"];
      let lineData = [[]];
      if (value == 0) {
        legendData = ["日度"];
        this.dayReports.forEach(item => {
          xAxisData.push(item.DATATIME);
          lineData[0].push(item.PRICE);
        });
      } else if (value == 1) {
        legendData = ["季度"];
        this.quarterReports.forEach(item => {
          xAxisData.push(item.DATATIME);
          lineData[0].push(item.PRICE);
        });
      } else if (value == 2) {
        legendData = ["年度"];
        this.yearReports.forEach(item => {
          xAxisData.push(item.DATATIME);
          lineData[0].push(item.PRICE);
        });
      }
      let paramsData = {
        xAxisData,
        legendData,
        lineData,
        colorList: [
          ["#F7A714", "#F7C671"],
          ["#5FC636", "#B7F59D"]
        ],
        colors: ["#F7A714", "#5FC636"]
      };
      commonEcharts.backgroundLine("priceCharts", paramsData);
    },
    //联动点击事件
    checkList(type, val, id, name) {
      if (type == 1) {
        this.active1 = val;
      } else if (type == 2) {
        this.active2 = val;
      } else if (type == 3) {
        this.active3 = val;
      }
      console.log(name, "name");
      if (name == "产品分类") {
        this.classifyId = id;
        this.active1 = 0;
        this.active2 = 0;
        this.getTypeList(0, id, "产品分类");
        this.currentPage = 1;
        this.getPriceQuotationListPage();
      }
      if (name == "产品类型") {
        this.getTypeList(id, this.classifyId, "产品类型");
        this.typeId = id;
        this.active2 = 0;
        // this.active3 = 0;
        // this.classifyId = 0;
        this.varietyId = 0;
        this.currentPage = 1;
        this.getPriceQuotationListPage();
      }
      if (name == "产品名称") {
        this.varietyId = id;
        this.currentPage = 1;
        this.getPriceQuotationListPage();
        // this.active3 = 0;
        // this.classifyId = 0;
      }

      this.getPriceQuotationListPage();
    },
    //表格分页
    currentChange(value) {
      this.currentPage = value;
      this.getPriceQuotationListPage();
    },
    reportCurrentChange(value) {
      this.reportCurrentPage = value
      this.indexReportSelectListByPage();
    },
    //茶青价格预警——接口数据
    async getCqPriceWarningData() {
      let res = await getCqPriceWarningData({
        varieties: this.cqVarietiesValue,
        varietyType: this.cqWarningTypeValue
      });
      if (res.data.code == 0 || res.data.code == 200) {
        this.getTeaWarningChartsData(res.data.data);
      }
    },
    //茶青价格预警
    getTeaWarningChartsData(datas) {
      this.$echarts
        .init(document.getElementById("teaPriceWarningCharts"))
        .dispose();
      var mychart = this.$echarts.init(
        document.getElementById("teaPriceWarningCharts") ||
        this.$refs.teaPriceWarningCharts
      );
      const hexToRgba = (hex, opacity) => {
        let rgbaColor = "";
        let reg = /^#[\da-f]{6}$/i;
        if (reg.test(hex)) {
          rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
            "0x" + hex.slice(3, 5)
          )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
        }
        return rgbaColor;
      };
      let legendName = ["价格情况", "最高值", "最低值"];
      let xData = [];
      let yData = [];
      let seriesData = [];
      let color = [
        "#F7A500",
        "#41C217",
        "#00C5CD",
        "#7ECDF4",
        "#EB6878",
        "#ACD598",
        "#00A879"
      ];
      let dataList = datas.list;
      let dataMaxList = datas.maxList;
      let dataMinList = datas.minList;
      let realData = [];
      let maxData = [];
      let minData = [];
      for (let i = 0; i < dataList.length; i++) {
        xData.push(dataList[i].dataTime.split(" ")[0]);
        realData.push(dataList[i].price);
        maxData.push(dataMaxList[i]);
        minData.push(dataMinList[i]);
      }
      yData = [realData, maxData, minData];
      if (yData.length > 0) {
        for (let i = 0; i < yData.length; i++) {
          seriesData.push({
            name: legendName[i],
            type: "line",
            color: color[i],
            showSymbol: false,
            symbol: "circle",
            symbolSize: 5,
            smooth: true,
            connectNulls: true,
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 1,
                    color: hexToRgba(color[0], 0.1)
                  },
                  {
                    offset: 0,
                    color: hexToRgba(color[0], 0.1)
                  }
                ])
              }
            },
            data: yData[i]
          });
        }
      } else {
        seriesData = [
          {
            name: [],
            type: "line",
            color: color,
            showSymbol: false,
            symbol: "circle",
            symbolSize: 5,
            smooth: true,
            connectNulls: true,
            data: yData
          }
        ];
      }
      var options = {
        legend: {
          data: legendName,
          show: false
        },
        xAxis: {
          data: xData
        },
        yAxis: {
          leftName: "元",
          namePadding: [0, -10, -5, 0]
        },
        grid: {
          top: "40"
        },
        series: seriesData
      };
      BarLineCharts(mychart, options);
    },
    //茶青价格预警-类型下拉点击事件
    changeCqWarning(val) {
      this.cqWarningTypeValue = val;
      this.getCqPriceWarningData();
    },
    //茶青价格预警-类型下拉点击事件
    changeCqVarieties(val) {
      this.cqVarietiesValue = val;
      this.getCqPriceWarningData();
    },
    //茶青价格指数——接口数据
    async getCqPriceIndexData() {
      let res = await getCqPriceIndexData({
        dataType: this.cqIndexDateTypeValue,
        varietyType: this.cqIndexTypeValue,
      });
      if (res.data.code == 0 || res.data.code == 200) {
        this.getCqIndexChartsData(res.data.data);
      }
    },
    // 保留小数
    fixed(num) {
      if (num.indexOf(".") > -1) {
        return Number(num).toFixed(2);
      }
      return num;
    },
    //茶青价格指数
    getCqIndexChartsData(datas) {
      this.cqToolTipList = [];
      this.$echarts
        .init(document.getElementById("cqPriceIndexCharts"))
        .dispose();
      var mychart = this.$echarts.init(
        document.getElementById("cqPriceIndexCharts") ||
        this.$refs.cqPriceIndexCharts
      );
      const hexToRgba = (hex, opacity) => {
        let rgbaColor = "";
        let reg = /^#[\da-f]{6}$/i;
        if (reg.test(hex)) {
          rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
            "0x" + hex.slice(3, 5)
          )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
        }
        return rgbaColor;
      };
      let legendName = [];
      let xData = [];
      let yData = [];
      let seriesData = [];
      let color = [
        "#F7A500",
        "#41C217",
        "#00C5CD",
        "#7ECDF4",
        "#EB6878",
        "#ACD598",
        "#00A879"
      ];
      let colorList = [
        [
          "rgba(1,208,245,.4)",
          "rgba(24,105,198,.4)",
          "rgba(192,190,89,.4)",
          "rgba(249,250,250,.4)",
          "rgba(0,160,233,0.4)",
          "rgba(0,230,152,0.4)",
          "rgba(130,165,203,0.4)"
        ],
        [
          "rgba(1,208,245,.1)",
          "rgba(24,105,198,.1)",
          "rgba(192,190,89,.1)",
          "rgba(249,250,250,.1)",
          "rgba(0,160,233,.1)",
          "rgba(0,230,152,.1)",
          "rgba(130,165,203,.1)"
        ]
      ];
      // xData = [
      //   "2022-05-11",
      //   "2022-05-12",
      //   "2022-05-13",
      //   "2022-05-14",
      //   "2022-05-15",
      // ];
      // yData = [
      //   [80, 120, 68, 88, 102],
      //   [30, 66, 52, 92, 81],
      //   [42, 55, 18, 108, 85],
      //   [65, 77, 48, 63, 75],
      //   [62, 48, 63, 120, 108],
      // ];
      // legendName = [
      //   "东方美人",
      //   "冠军红.私房茶",
      //   "福安红",
      //   "坦洋红.1915",
      //   "红韵天成",
      // ];
      xData = datas.dates;
      yData = datas.pricesList;
      legendName = datas.varieties;
      if (legendName.length > 0) {
        for (let i = 0; i < legendName.length; i++) {
          this.cqToolTipList.push({
            name: legendName[i],
            index: this.fixed(yData[i][yData[i].length - 1]),
            color: color[i]
          });
        }
      }

      // let res = await getTeaPriceIndexData({varietyType: this.cqYaVarietyPriceValue});
      // if(res.data.code == 0){
      //   legendName = res.data.data.varieties;
      //   yData = res.data.data.pricesList;
      //   xData = res.data.data.dates;
      // }

      if (yData.length > 0) {
        for (let i = 0; i < yData.length; i++) {
          for (let j = 0; j < yData[i].length; j++) {
            if ((yData[i][j] ?? '') !== '') {
              yData[i][j] = this.fixed(yData[i][j])
            }
          }
          seriesData.push({
            name: legendName[i],
            type: "line",
            color: color[i],
            showSymbol: false,
            symbol: "circle",
            symbolSize: 5,
            smooth: true,
            connectNulls: true,
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 1,
                    color: hexToRgba(color[0], 0.1)
                  },
                  {
                    offset: 0,
                    color: hexToRgba(color[0], 0.1)
                  }
                ])
              }
            },
            data: yData[i]
          });
        }
      } else {
        seriesData = [
          {
            name: [],
            type: "line",
            color: color,
            showSymbol: false,
            symbol: "circle",
            symbolSize: 5,
            smooth: true,
            connectNulls: true,
            data: yData
          }
        ];
      }
      var options = {
        legend: {
          data: legendName
        },
        // mytooltip: {
        //   formatter: function (datas) {
        //     return datas.toFixed(2);
        //     //或者是下面这种，效果是一样的
        //     //return datas.value.toFixed(2);
        //   }
        // },
        xAxis: {
          data: xData
        },
        yAxis: {
          leftName: "%",
          namePadding: [0, -8, -5, 0]
        },
        grid: {
          top: "40"
        },
        series: seriesData
      };
      // mychart.setOption(options);

      BarLineCharts(mychart, options);
    },
    //茶青价格指数-类型下拉点击事件
    changeCqIndex(val) {
      this.cqIndexTypeValue = val;
      this.getCqPriceIndexData();
    },
    changeCqIndexDate(val) {
      this.cqIndexDateTypeValue = val;
      this.getCqPriceIndexData();
    },
    changeIndexReportDate(val) {
      this.indexReportTypeValue = val;
      this.indexReportSelectListByPage();
    }
  }
};
</script>

<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/priceQuotation.scss";
</style>
